import React from 'react';
import { useParams, Link } from 'react-router-dom';
import bannerBg from '../assets/img/page-banner.jpg';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import PageBanner from '../components/PageBanner';
import productsData from '../components/data/products';
import ProductSidebar from '../components/ProductSidebar';

function ProductDetails() {
    const { category, slug } = useParams();

    // Find the specific product
    const product = productsData.find(
        (p) => p.slug === slug && p.category === category
    );

    if (!product) {
        return (
            <>
                <Header1 />
                <PageBanner bannerBg={bannerBg} currentPage="Product Not Found" heading="Error 404" />
                <section className="section-padding text-center">
                    <h2>Product not found!</h2>
                    <br />
                    <Link to="/products" className="theme-btn">Back to Categories</Link>
                </section>
                <Footer1 />
            </>
        );
    }

    return (
        <>
            <Header1 />
            <PageBanner
                bannerBg={bannerBg}
                currentPage={product.title}
                heading={product.title}
            />

            <section className="project-details-wrapper section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-4 mt-5 mt-md-0 col-12 order-2 order-md-1">
                            <ProductSidebar />
                        </div>
                        <div className="col-lg-9 col-md-8 col-12 order-1 order-md-2">
                            <div className="project-details-content">
                                <div className="project-thumb mb-4">
                                    <img src={product.thumbnail} alt={product.title} className="img-fluid w-100" style={{ maxHeight: '500px', objectFit: 'cover', borderRadius: '10px' }} />
                                </div>
                                <div className="row">
                                    <div className="col-lg-8">
                                        <h2>{product.title}</h2>
                                        <p className="mt-4">
                                            This is a high-quality {product.title} belonging to our {category} category. It is built with premium materials to ensure longevity and superior performance. Welcome to check out more specifications below.
                                        </p>
                                    </div>
                                    <div className="col-lg-4">
                                        <div className="project-info-box" style={{ background: '#f8f9fa', padding: '30px', borderRadius: '8px' }}>
                                            <h4>Product Info</h4>
                                            <ul className="list-unstyled mt-3">
                                                <li className="mb-2"><strong>Category:</strong> <span style={{ textTransform: 'capitalize' }}>{product.category}</span></li>
                                                <li className="mb-2"><strong>Manufacture Year:</strong> {product.meta || 'N/A'}</li>
                                                <li className="mb-2"><strong>Vendor:</strong> {product.author || 'Vedant Tech'}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer1 />
        </>
    );
}

export default ProductDetails;
